import React from 'react'
import SelectComponent, { SelectOption } from '@Components/Selectors/Select'
import './index.scss'

interface PayeeFilterProps {
    payeeOptions: SelectOption[]
    setPayee: (value: SelectOption) => void
    selectedPayee?: SelectOption
    label: string
}

const PayeeFilter = (props: PayeeFilterProps) => {
    const { payeeOptions, setPayee, selectedPayee, label } = props

    return (
        <div className="payee-filter-row">
            <div className="filter-item">
                <p className="small bold">
                    <label htmlFor="payee-options">{label}</label>
                </p>
                <SelectComponent
                    options={payeeOptions}
                    onValueChange={setPayee}
                    selectedValue={selectedPayee}
                    name="payee-options"
                />
            </div>
        </div>
    )
}

export default PayeeFilter
